import TimeTableMetaList from "@/controllers/timetable_meta/timetable-meta-list.js";
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import CONFIG from "@/assets/js/config.js";
import AdvancedLaravelVuePaginate from "advanced-laravel-vue-paginate";
import "advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css";

export default {
  extends: TimeTableMetaList,
  name: "timetableTemplateList",
  components: {
    MainLayout,
    Loading,
    AdvancedLaravelVuePaginate,
  },

  data() {
    return {
      noDataMsg: CONFIG.NO_DATA_FOUND,
      isFilterOpen: false,
      isLoading: false,
      searchTemplateName: '',
      timeTableMetaData: {},
      disabled: true,

      searchBtnStatus: false,
      searchedData: null,
      isSearched: false,
    };
  },

  methods: {
    getTimeTableMeta(page = 1) {
      this.searchBtnStatus = false;
      axios.get("timetableMeta/list?page=" + page, {
        params: {
          campus_id: this.$store.state.user.campus_id
        }
      })
        .then(response => {
          this.timeTableMetaData = response.data;
          this.isLoading = false;
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    reset() {
      this.searchTemplateName = '';
      this.isLoading = true;
      this.getTimeTableMeta();
      this.isSearched = false;
    },

    search(page = 1) {
      this.searchBtnStatus = true;
      this.isLoading = true;
      const params = {
        template_name: this.searchTemplateName
      };
      this.searchedData = {
        ...params,
        search_status: this.searchBtnStatus
      };
      this.isSearched = true;
      axios.get("timetableMeta/search?page=" + page, { params })
        .then((response) => {
          this.timeTableMetaData = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    excelDownload() {
      this.isLoading = true;
      const params = this.isSearched && this.searchedData
        ? { ...this.searchedData, campus_id: this.$store.state.user.campus_id }
        : { campus_id: this.$store.state.user.campus_id };
      axios.get('timetableMeta/excelDownload', {
        params,
        responseType: 'arraybuffer'
      })
        .then(response => {
          this.isLoading = false;
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          let date = new Date();
          fileLink.setAttribute('download', `timetable_template_list_${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    }
  },

  mounted() {
    this.isLoading = true;
    this.getTimeTableMeta();
  },
};
